export default [
  {
    label: "Dashboard Chargeback",
    to: "/fraud/chargeback-dashboard",
    icon: "fas fa-chart-line",
    controller: "Chargeback",
    action: "GetDashboard"
  },
  {
    label: "Chargebacks",
    to: "/fraud/chargeback",
    icon: "fas fa-money-check-alt",
    controller: "Chargeback",
    action: "List"
  },
  // {
  //   label: "Chargebacks Marketplace",
  //   to: "/fraud/chargebacks-marketplace-dashboard",
  //   icon: "fas fa-comment-dollar",
  //   controller: "Chargeback",
  //   action: "GetMarketplace"
  // },
  // {
  //   label: "Emailage",
  //   to: "/fraud/emailage",
  //   icon: "fas fa-envelope-open-text",
  //   controller: "Emailage",
  //   action: "List"
  // },
  // {
  //   label: "Transações Cartão Crédito Recusadas",
  //   to: "/fraud/transaction-credit-card-refused",
  //   icon: "fas fa-credit-card",
  //   controller: "Transaction",
  //   action: "List"
  // },
  {
    label: "Transações suspeitas",
    to: "/fraud/suspectTransaction",
    icon: "fas fa-user-shield",
    controller: "SuspectTransaction",
    action: "List"
  },
  {
    label: "Blocklist",
    to: "/fraud/blockList",
    icon: "fas fa-user-alt-slash",
    controller: "BlockList",
    action: "List"
  },
  // {
  //   label: "ICC",
  //   to: "/fraud/merchantLimits",
  //   icon: "fas fa-list-alt",
  //   controller: "MerchantLimits",
  //   action: "List"
  // },
  {
    label: "Compliance OFAC/PEP",
    to: "/compliance/alertas-merchant",
    icon: "fas fa-user-secret",
    controller: "AlertaMerchant",
    action: "Listar"
  }
];



// WEBPACK FOOTER //
// ./src/data/menu-item-internal/risk-management-menu.js